<template>
  <FormSelect
    label="Role"
    :values="values"
    :options="options"
    :rules="rules"
    :loading="loading"
    :disabled="loading"
    :multiple="multiple"
    @updateStore="onUpdateStore"
  />
</template>

<script>
import { ref, computed, watch, onBeforeMount } from 'vue'
import { FormSelect } from '@/components/inputs'
import { FORMAT, VALIDATION, Toast, fetchData } from '@/tools'

export default {
  name: 'SelectRoles',
  inheritAttrs: true,
  emits: ['updateStore'],
  components: {
    FormSelect
  },
  props: {
    values: {
      type: [String, Number, Array],
      default: null
    },
    multiple: {
      type: Boolean,
      default: false
    },
    withAll: {
      type: Boolean,
      default: false
    }
  },
  setup(props, { emit }) {
    const { data, error, loading, get } = fetchData()
    const { showToast } = Toast()
    const options = ref([])
    const rules = computed(() => {
      return props.multiple ? [VALIDATION.requiredArray] : [VALIDATION.required]
    })

    const onUpdateStore = data => {
      emit('updateStore', data)
    }

    onBeforeMount(() => {
      get('v1/roles')

      watch([data, error, loading], () => {
        if (!loading.value) {
          if (error?.value) {
            showToast('There was a problem fetching roles.', 'danger')
          } else if (data?.value) {
            options.value = data?.value?.map(item => ({
              label: FORMAT.capitalizeEachWord(item?.name),
              value: item?.id
            }))

            if (props.withAll) {
              options.value.unshift({
                label: 'All',
                value: '0'
              })
            }
          }
        }
      })
    })

    return { options, rules, loading, VALIDATION, onUpdateStore }
  }
}
</script>
